import { Component, Mixins, Watch } from 'vue-property-decorator';
import TextTemplateMixin from './TextTemplateMixin';
import StreamlabsApi from '@/apis/streamlabs-api';
import { VariableMenu } from 'streamlabs-beaker';
import { EComponentType } from '@/helpers/editor';
import { EModalName } from '@/helpers/modal';

const VARIABLE_REGEX = /{([^}]+)}/g;

@Component({
  components: {
    SVariableMenu: VariableMenu,
  }
})
export default class StreamLabelTemplate extends Mixins(TextTemplateMixin) {
  async mounted() {
    this.updateTextValue();
    if (this.component.css.fontFamily) await this.loadFont();

    // polling 1 min interval
    if (!this.streamLabelPoll) {
      await this.fetchStreamLabelData();
      this.streamLabelPoll = setInterval(this.fetchStreamLabelData, 1000 * 60);
    }

    if (!this.isEditor) this.replaceVariableWithStreamLabel();
  }

  get streamLabelVariableList() {
    if (!this.streamLabelData) return [];

    const variables = Object.keys(this.streamLabelData).map((key) => {
      return { variable: `{${key}}`, description: this.streamLabelData[key] };
    });

    return variables;
  }

  get existingVariableList(): string[] {
    let current = null;
    const streamLabelVariables: string[] = [];

    while ((current = VARIABLE_REGEX.exec(this.component.value))) {
      streamLabelVariables.push(current[1]);
    }

    return streamLabelVariables;
  }

  get isVariableValid(): boolean {
    if (!this.streamLabelData) return false;

    return this.existingVariableList.every((variable) => {
      return Object.keys(this.streamLabelData).includes(variable);
    });
  }

  destroyed() {
    const hasStreamLabelComponent = this.components && this.components.some((component) => component.type === EComponentType.streamLabel);
    if (!hasStreamLabelComponent) {
      clearInterval(this.streamLabelPoll);
      this.streamLabelPoll = null;
    }
  }

  @Watch('streamLabelData', { deep: true })
  @Watch('textValue')
  streamLabelDataOnUpdate() {
    if (!this.isEditor) this.replaceVariableWithStreamLabel();
  }

  async fetchStreamLabelData() {
    const streamLabelResponseData = this.uuid ? await StreamlabsApi.getStreamLabelDataByToken(this.uuid, this.sessionId) : await StreamlabsApi.getStreamLabelData();
    this.streamLabelData = streamLabelResponseData.data;
  }

  onVariableSelected(input) {
    const regex = /^.*?\{(?!.*?\})[^}]*$/g;

    this.textValue = this.textValue.replace(regex, '');
    this.textValue += input;
  }

  openVariableMenu() {
    this.$modal.show(EModalName.streamLabel);
  }

  replaceVariableWithStreamLabel() {
    let streamLabelString = this.component.value;

    if (this.streamLabelData) {
      this.existingVariableList.forEach((key) => {
        streamLabelString = streamLabelString.replace(`{${key}}`, this.streamLabelData[key] === undefined ? '' : this.streamLabelData[key]);
      });
    }

    this.textValue = streamLabelString;
  }
}
